// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  pointId: __t.u64().primaryKey().name("point_id"),
  name: __t.string(),
  gridE: __t.f64().name("grid_e"),
  gridN: __t.f64().name("grid_n"),
  gridElev: __t.f64().name("grid_elev"),
  groundE: __t.f64().name("ground_e"),
  groundN: __t.f64().name("ground_n"),
  groundElev: __t.f64().name("ground_elev"),
  lat: __t.f64(),
  lon: __t.f64(),
  elevM: __t.f64().name("elev_m"),
  datumLabel: __t.string().name("datum_label"),
  enabled: __t.bool(),
});
